import { ENTORNO } from "../utils/constantes";

export class apiIdioma {
  baseApi = ENTORNO.BASE_API;

  async obtener() {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.Idioma_Obtener}`;

      const parametros = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${getToken()}`,
        },
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();

      if (respuesta.status !== 200) throw respuestaJson;

      return respuestaJson;
    } catch (error) {
      throw error;
    }
  }
}
